module.exports = __webpack_public_path__ + "static/media/W_Calendar_02.9e6d18f8.png";